import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { FirmRole } from '@/_types/models/firmRole';
import { _callBackend } from '@/_api/api';

export const getFirmRoles = async ({
  token,
}: APIRequest): APIResponsePromise<Array<FirmRole>> =>
  await _callBackend('/firm_roles', 'GET', null, token);

export const createDefaultRoles = async ({
  token,
}: APIRequest): APIResponsePromise<Array<FirmRole>> =>
  await _callBackend('/firm_roles/create_default_roles', 'POST', null, token);

export const getFirmRole = async ({
  firmRoleId,
  token,
}: APIRequest<{
  firmRoleId: number;
}>): APIResponsePromise<FirmRole> =>
  await _callBackend(`/firm_roles/${firmRoleId}`, 'GET', null, token);

export const createFirmRole = async ({
  permissionIds,
  roleName,
  token,
  notificationIds,
}: APIRequest<{
  roleName: string;
  permissionIds: Array<number>;
  notificationIds: Array<number>;
}>): APIResponsePromise<FirmRole> =>
  await _callBackend(
    '/firm_roles',
    'POST',
    {
      role_name: roleName,
      permission_ids: permissionIds,
      notification_ids: notificationIds,
    },
    token,
  );

export const updateFirmRole = async ({
  firmRoleId,
  permissionIds,
  roleName,
  notificationIds,
  token,
}: APIRequest<{
  roleName: string;
  firmRoleId: number;
  permissionIds: Array<number>;
  notificationIds: Array<number>;
}>): APIResponsePromise<FirmRole> =>
  await _callBackend(
    `/firm_roles/${firmRoleId}`,
    'PATCH',
    {
      role_name: roleName,
      permission_ids: permissionIds,
      notification_ids: notificationIds,
    },
    token,
  );

export const deleteFirmRole = async ({
  firmRoleId,
  token,
}: APIRequest<{
  firmRoleId: number;
}>): APIResponsePromise<FirmRole> =>
  await _callBackend(`/firm_roles/${firmRoleId}`, 'DELETE', null, token);

export const downloadBulkAssignFirmRoleTemplate = async ({
  token,
}: APIRequest): APIResponsePromise =>
  await _callBackend(
    '/firm_role_assignments/download_bulk_assign_firm_role_assignments_from_spreadsheet_template',
    'POST',
    null,
    token,
  );

export const bulkAssignFirmRolesToEntities = async ({
  token,
  file,
}: APIRequest<{
  file: File;
}>): APIResponsePromise => {
  const formData = new FormData();
  formData.append('file', file);

  return await _callBackend(
    '/firm_role_assignments/bulk_assign_firm_roles_to_entities_by_spreadsheet',
    'POST',
    formData,
    token,
  );
};
